module.exports = "data:text/x-markdown;base64,VGhlIGdvYWwgb2YgdGhpcyBsZXZlbCBpcyB2ZXJ5IGVhc3kuCgpZb3UganVzdCBoYXZlIHRvIHNldCBgb3duZXJgIGZyb20gKipCb1l1IENoZW4qKiB0byAqKkJpbGwgSHN1KiouCgoKClRoaW5ncyB0aGF0IG1pZ2h0IGhlbHA6CiogVW5kZXJzdGFuZGluZyBob3cgZXh0Y29kZXNpemUgd29ya3MKCgo="


//////////////////
// WEBPACK FOOTER
// ./gamedata/descriptions/levels/Fomo4D.md
// module id = 1349
// module chunks = 0